<template lang="pug">
.v-menu.menu(v-if="data")
	.menu__item(v-for="item in data.items")
		component.menu__item-btn(:is="item.link ? 'a' : 'button'" :href="item.link") {{item.text}}
			v-svg-icon.menu__item-btn-arrow(v-if="item.items" icon="select-arrow")
		.menu__panel(v-if="item.items")
			.menu__panel-inner
				.menu__panel-cols(v-if="item.cols")
					.menu__panel-col(v-for="col in item.cols")
						.menu__panel-item(v-for="menuItem in col")
							component(v-if="menuItem.title" :is="menuItem.title.link ? 'a' : 'div'" :class="[menuItem.title.link ? 'menu__panel-item-title-link' : 'menu__panel-item-title', menuItem.title.active ? 'active' : '']" :href="menuItem.title.link ? menuItem.title.link : ''")
								| {{menuItem.title.text}}
								v-svg-icon.menu__panel-item-title-link-icon(icon="arrow-right")
							v-navigation-links.menu__panel-item-links(v-if="menuItem.links" :items="menuItem.links")
				.menu__panel-aside(v-if="item.aside")
					.menu__panel-aside-tilte(v-if="item.aside.title") {{item.aside.title}}
					.menu__panel-aside-links(v-if="item.aside.links")
						a.menu__panel-aside-link(v-for="linkItem in item.aside.links" :href="linkItem.link") {{linkItem.text}}
	.menu__item.menu__item--more(v-if="data.more")
		v-dropdown(:title="data.more.title")
			template(#btn)
				button.menu__item-btn(type="button") {{data.more.text}}
			template(#content)
				v-navigation-links.menu__panel-item-links(v-if="data.more.links" :items="data.more.links")
</template>

<script>

import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			if (data.items) {
				data.items.forEach((item, i) => this.data.items[i].cols = item.items ? this.sortCols(item) : null)
			}
		},

		sortCols(data) {
			let obj = {};
			data.items.forEach(item => {
				let key = item.group || 0;
				obj[key] ? obj[key].push(item) : obj[key] = [item];
			})
			return Object.values(obj)
		}
	}
}

</script>